import { TabNav } from "../../../../patterns/TabNav.js";
import type { AccountTabsContent } from "../../accountContent.js";

/** The shopper's account tabs (Vault, Settings, History), each its own URL. */
export function AccountTabs({ label, items }: AccountTabsContent) {
  return <TabNav label={label} items={items} />;
}
